import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/admin/prompt-template-editor.vue'

export default class extends Controller {
  static values = {
    template: Object
  }

  connect() {
    this.vue = createApp(App, {
      template: this.templateValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
